import { render, staticRenderFns } from "./downloadDetail.vue?vue&type=template&id=26bbec1c&scoped=true&"
import script from "./downloadDetail.vue?vue&type=script&lang=js&"
export * from "./downloadDetail.vue?vue&type=script&lang=js&"
import style0 from "./downloadDetail.vue?vue&type=style&index=0&id=26bbec1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bbec1c",
  null
  
)

export default component.exports